import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCloseSharp, BsImages } from '../components/utils/icons';
import { useImageResizer } from './ImageResizer';


const ImageUploadWithResize = ({ 
  imageShow, 
  setImageShow, 
  setImage, 
  currentColor,
  label = "Upload Image",
  required = false,
  maxWidth = 1024,
  maxHeight = 1024,
  quality = 80
}) => {
  const { t } = useTranslation();
  const { resizeImage, isResizing } = useImageResizer();

  const inmageHandle = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // ضغط الصورة
      const resizedImage = await resizeImage(file, { maxWidth, maxHeight, quality });
      setImage(resizedImage);
      
      // إنشاء رابط المعاينة
      const imageUrl = { url: URL.createObjectURL(resizedImage) };
      setImageShow(imageUrl);
    } catch (error) {
      console.error("Error processing image:", error);
      // في حالة الخطأ، استخدم الصورة الأصلية
      setImage(file);
      const imageUrl = { url: URL.createObjectURL(file) };
      setImageShow(imageUrl);
    }
  };

  const changeImage = async (img) => {
    if (img) {
      try {
        const resizedImage = await resizeImage(img, { maxWidth, maxHeight, quality });
        const tempUrl = { url: URL.createObjectURL(resizedImage) };
        setImageShow(tempUrl);
        setImage(resizedImage);
      } catch (error) {
        const tempUrl = { url: URL.createObjectURL(img) };
        setImageShow(tempUrl);
        setImage(img);
      }
    }
  };

  const removeImage = () => {
    setImage(null);
    setImageShow(null);
  };

  return (
    <div className="w-full">
      <label className="pb-2 text-tcolor-5 text-md font-kufi">
        {t(label)}
        {required && <span className="text-red-500">*</span>}
      </label>
      
      {isResizing && (
        <div className="text-center py-2 text-blue-500">
          {t("Compressing image...")}
        </div>
      )}
      
      <input
        type="file"
        id="upload"
        className="hidden"
        onChange={inmageHandle}
        accept="image/*"
      />

      {imageShow ? (
        <div className="h-[180px] w-[180px]  relative">
          <label htmlFor="0">
            <img
              className="w-full h-full rounded-lg border object-cover"
              src={imageShow.url}
              alt=""
              style={{ borderColor: currentColor }}
            />
          </label>
          <input
            onChange={(e) => changeImage(e.target.files[0])}
            type="file"
            id="0"
            className="hidden"
            accept="image/*"
          />
          <span
            onClick={removeImage}
            className="p-2 z-10 cursor-pointer hover:shadow-lg text-white absolute top-1 right-1 rounded-full"
            style={{ backgroundColor: currentColor }}
          >
            <IoCloseSharp />
          </span>
        </div>
      ) : (
        <label
          className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
          htmlFor="image"
          style={{ borderColor: currentColor }}
        >
          <span>
            <BsImages size={40} color={currentColor} />
          </span>
          <span
            className="text font-kufi text-md"
            style={{ color: currentColor }}
          >
            {t("Select Image")}
          </span>
        </label>
      )}

      <input
        onChange={inmageHandle}
        className="hidden"
        type="file"
        id="image"
        accept="image/*"
      />
    </div>
  );
};

export default ImageUploadWithResize;